import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Readers } from '../../../asset/utils/Readers';
import { StudentBook } from '../../../asset/utils/StudentBook';
import { WorkBook } from '../../../asset/utils/WorkBook';
import { setBookInfo } from '../../../store/BookSlice';
import { Video } from '../../_atoms/Video';
import { Frame } from '../../_molecules/Frame';
import { Mask } from '../../_molecules/Mask';
import { Memo } from '../../_molecules/Memo';
import { PopupCommon } from '../../_molecules/PopupCommon';
import { AudioListWrap } from '../../_organisms/AudioListWrap';
import { AudioPlayerWrap } from '../../_organisms/AudioPlayerWrap';
import { BookWrap } from '../../_organisms/BookWrap';
import { CardSliderWrap } from '../../_organisms/CardSliderWrap';
import { GameWrap } from '../../_organisms/GameWrap';
import { PageWrap } from '../../_organisms/PageWrap';
import { SlideMenu } from '../../_organisms/SlideMenu';
import { VideoProgressWrap } from '../../_organisms/VideoProgressWrap';

const Section = styled.section`
  position: absolute;
  top: 0;
  width: 2082px;
  transition: left 0.3s;
  z-index: 0;
  height : 100%;

  ${(props) => props.act ? 'left : 0;' : 'left: -81px;'}
`;

export const EbookTemplate = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    // BookList
    if (state.book.current_menu === 0 || state.book.current_menu === 2) {
      // StudentBook
      if (state.book.current_content === 0) {
        dispatch(setBookInfo(StudentBook[state.book.current_book]));
        // WorkBook
      } else if (state.book.current_content === 1) {
        dispatch(setBookInfo(WorkBook[state.book.current_book]));
        // Readers
      } else if (state.book.current_content === 2) {
        dispatch(setBookInfo(Readers[state.book.current_book]));
      }
    }
  }, [state.book.current_book, state.book.current_menu, state.book.current_content, state.book.current_unit, state.book.current_page]);

  return (
    <>
      {/* Audio Track */}
      {state.common.pop_audio && (
        <PopupCommon type="audio">
          <AudioListWrap />
          <AudioPlayerWrap />
        </PopupCommon>
      )}

      {/* animation */}
      {state.common.pop_video && (
        <PopupCommon type="video">
          <Video />
          <VideoProgressWrap />
        </PopupCommon>
      )}

      {/* flashcard */}
      {state.common.pop_card && (
        <PopupCommon type="card">
          <CardSliderWrap />
        </PopupCommon>
      )}

      {/* game */}
      {state.common.pop_game && (
        <PopupCommon type="game">
          <GameWrap />
        </PopupCommon>
      )}

      <Frame type='ebook'>
        <Section act={state.menu.act}>
          <BookWrap/>
          <PageWrap/>

          {/* memo */}
          {state.tool.memo_act && (
            <Memo />
          )}

          {/* mask */}
          {state.tool.mask_act && (
            <Mask />
          )}
        </Section>
        <SlideMenu />
      </Frame>
    </>
  );
};